<template>
  <div>
    <div v-if="!userAgent">
      <!--banner  -->
      <div class="banner">
        <img :src="image" alt />
      </div>
      <div class="content">
        <div class="tit">上海赛捷能源科技有限公司</div>
        <div class="phone">
          <div>
            <img src="@/assets/images/dianhua.png" alt />
            <p>{{tel}}</p>
          </div>
          <div>
            <img src="@/assets/images/email.png" alt />
            <p>{{email}}</p>
          </div>
          <div>
            <img src="@/assets/images/pos.png" alt />
            <p>{{address}}</p>
          </div>
        </div>
        <div class="map"></div>
      </div>
      <!-- 地图 -->
      <div class="map">
        <img src="@/assets/images/map.png" alt />
        <!-- <baidu-map v-bind:style="mapStyle" class="bm-view" ak="你的百度地图ak" :center="center" :zoom="zoom" :scroll-wheel-zoom="true"
                @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
                <bm-view style="width: 100%; height:500px;"></bm-view>
                <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                </bm-marker>
                   <bm-control :offset="{width: '10px', height: '10px'}">
                    <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 999999}">
                        <input type="text" placeholder="请输入搜索关键字" class="serachinput">
                    </bm-auto-complete>
                </bm-control>    
                <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
        </baidu-map>-->
      </div>
    </div>
    <div v-else>
      <!--banner  -->
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <div class="content1">
        <div class="tit1">上海赛捷能源科技有限公司</div>
        <div class="phone1">
          <div>
            <img src="@/assets/images/dianhua.png" alt />
            <p>{{tel}}</p>
          </div>
          <div>
            <img src="@/assets/images/email.png" alt />
            <p>{{email}}</p>
          </div>
          <div>
            <img src="@/assets/images/pos.png" alt />
            <p>{{address}}</p>
          </div>
        </div>
      </div>
      <!-- 地图 -->
      <div class="map1">
        <img src="@/assets/images/map.png" alt />
        <!-- <baidu-map v-bind:style="mapStyle" class="bm-view" ak="你的百度地图ak" :center="center" :zoom="zoom" :scroll-wheel-zoom="true"
                @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
                <bm-view style="width: 100%; height:500px;"></bm-view>
                <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                </bm-marker>
                   <bm-control :offset="{width: '10px', height: '10px'}">
                    <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 999999}">
                        <input type="text" placeholder="请输入搜索关键字" class="serachinput">
                    </bm-auto-complete>
                </bm-control>    
                <bm-local-search :keyword="keyword" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
        </baidu-map>-->
      </div>
    </div>
  </div>
</template>
<script>
// import {BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker} from 'vue-baidu-map'
export default {
  //  components: {
  //     BaiduMap,
  //     BmControl,
  //     BmView,
  //     BmAutoComplete,
  //     BmLocalSearch,
  //     BmMarker
  //   },
  name: "Contact",
  data: function () {
    return {
      image: "",
      address: "",
      tel: "",
      email: "",
      //   showMapComponent: t:his.value,
      //   keyword: '',
      //   mapStyle: {
      //     width: '100%',
      //     height: this.mapHeight + 'px'
      //   },
      //   center: {lng: 121.600727, lat: 31.345076},
      //   zoom: 15
    };
  },
  // watch: {
  //   value: function (currentValue) {
  //     this.showMapComponent = currentValue
  //     if (currentValue) {
  //       this.keyword = ''
  //     }
  //   }
  // },
  methods: {
    /***
     * 地图点击事件。
     */
    // getClickInfo (e) {
    //   this.center.lng = e.point.lng
    //   this.center.lat = e.point.lat
    // },
    // syncCenterAndZoom (e) {
    //   const {lng, lat} = e.target.getCenter()
    //   this.center.lng = lng
    //   this.center.lat = lat
    //   this.zoom = e.target.getZoom()
    // },
  },
  mounted() {
    var that = this;
    that.$http.get("images/contact").then(function (res) {
      //轮播
      that.image = res.data.data.image;
    });
    that.$http.get("contact/index").then(function (res) {
      //联系我们
      that.address = res.data.data.address;
      that.email = res.data.data.email;
      that.tel = res.data.data.tel;
    });
  },
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.content {
  width: 80%;
  margin: 0 auto;
  .tit {
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #333;
    margin: 5% auto;
  }
  .phone {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 3rem;
    div {
      width: 30%;
      height: 3rem;
      padding-bottom: 3rem;
      text-align: center;
      border: 1px solid #43ae85;
      img {
        margin-top: -1.5rem;
      }
      p {
        color: #333;
        font-size: 14px;
        text-align: center;
        margin-top: 1rem;
        font-weight: bold;
      }
    }
  }
}
.map {
  width: 80%;
  height: 50%;
  margin: 0 auto;
  padding-bottom: 5rem;
  img {
    width: 100%;
    height: 100%;
  }
}
// .serachinput {
//         width: 300px;
//         box-sizing: border-box;
//         padding: 9px;
//         border: 1px solid #dddee1;
//         line-height: 20px;
//         font-size: 16px;
//         height: 38px;
//         color: #333;
//         position: relative;
//         border-radius: 4px;
//         -webkit-box-shadow: #666 0px 0px 10px;
//         -moz-box-shadow: #666 0px 0px 10px;
//         box-shadow: #666 0px 0px 10px;
//         outline: none;
//     }

.banner1 {
  width: 100%;
  img {
    width: 100%;
    height: 7rem;
  }
}
.content1 {
  width: 90%;
  margin: 0 auto;
  .tit1 {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin: 5% auto;
  }
  .phone1 {
    margin: 0 auto;
    justify-content: space-between;
    padding-bottom: 5%;
    margin-top:2.5rem;
    display: flex;
  > div {
    width: 32%;
    border: 1px solid #43ae82;
    padding: 1% 0;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 2rem;
    }
    p {
      width:90%;
      margin:0 auto;
      line-height:0.7rem;
      margin-top: 1rem;
      font-size: 9px;
      color: #333;
      word-wrap:break-word
    }
  }
}
}
.map1 {
  width: 90%;
  height: 50%;
  margin: 0 auto;
  padding-bottom: 2rem;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
